import * as React from 'react';

import { AppConfigurationStore } from '../stores/AppConfigurationStore';
import { Toolbar, ToolbarButtonConfig } from './Toolbar';
import { ToolbarButtonWall } from './ToolbarButtonWall';

export class FloatingToolbar extends Toolbar {
    public render(): JSX.Element | null {
        if (this.state.hiddenDueOrientationChange || AppConfigurationStore.getState().inApp || !this.state.activeView) {
            return null;
        }

        const tContent: ToolbarButtonConfig = this.toolbarButtons();
        const elementBoundingRect: ClientRect | DOMRect = this.state.activeView.getBoundingClientRect();
        const toolbarStyle: React.CSSProperties = {
            position: 'absolute',
            left: elementBoundingRect.left + .5 * elementBoundingRect.width - .5 * tContent.width,
            top: elementBoundingRect.top > 58 ? elementBoundingRect.top + 2 : elementBoundingRect.top,
            maxWidth: tContent.width + 2,
            width: tContent.width + 2,
        };

        if (jQuery('.page-container').hasClass('page-container-banner')) {
            (toolbarStyle.top as number) -= 57;
        }

        if (!AppConfigurationStore.getState().touchDevice) {
            toolbarStyle.overflow = 'visible';
        }

        return (
            <div className="core-toolbar floating-toolbar" style={toolbarStyle}>
                <ToolbarButtonWall/>
                {tContent.elements}
                {
                    tContent.extraButtons.length && this.state.extraButtons ?
                    <div className="extra-buttons with-popupflag top-arrow align-right">{tContent.extraButtons}</div> :
                    null
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/FloatingToolbar.tsx